import Catalyst from '@Services/Catalyst';

export const SECTION_TYPE = {
  PAI: 'pai',
  IKTOS: 'iktos',
  PUBLISHED: 'published',
};

export const onProjectParametersSectionClick = (sectionType, isButton, isOpen) => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: `${isButton ? 'button' : 'chevron'}:${sectionType} ${isOpen ? 'open' : 'close'} edit parameters`,
  });
};
